// src/components/operationCenter/widgets/token/performance/TwSeasonalPerformanceWidget.tsx
// SeasonalPerformanceCard receives its data via props, so we call the hook here.
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import SeasonalPerformanceCard from "@/components/tokenPage/performance/SeasonalPerformanceCard";
import { useHistoricalReturns } from "@/hooks/tokenPage/financialValue/useHistoricalReturns";

interface SeasonalInnerProps {
  tokenId: string;
}

const SeasonalInner: React.FC<SeasonalInnerProps> = ({ tokenId }) => {
  const { data, isLoading, isError, error, refetch } = useHistoricalReturns(tokenId);
  return (
    <SeasonalPerformanceCard
      historicalReturnsData={data}
      isLoading={isLoading}
      isError={isError}
      error={error instanceof Error ? error : null}
      refetch={refetch}
    />
  );
};

const TwSeasonalPerformanceWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  const tokenId = config.tokenId || config.ticker.toLowerCase();
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={[]}>
        {tokenId && <SeasonalInner tokenId={tokenId} />}
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwSeasonalPerformanceWidget;
